module.exports = __webpack_public_path__ + "img/fachadaeliza2.16e58549.png";